import { render, staticRenderFns } from "./render-unit-size.vue?vue&type=template&id=64edfa25&"
import script from "./render-unit-size.vue?vue&type=script&lang=js&"
export * from "./render-unit-size.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports